import { serviceVariationLabel } from "@/services/backend/omni/servicevariation/types/service-variation";
import t from "@/lang/lang";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";
import { ScopeOfWork } from "../../scope-of-work/types/scope-of-work";

/**
 * OfferScopeOfWorkSelect selects one of the scope of works of an offer by
 * its id, showing its title and service variation.
 */
export function OfferScopeOfWorkSelect({
  scopeOfWorks,
  value,
  onValueChange,
  disabled,
}: {
  scopeOfWorks: ScopeOfWork[];
  value?: string;
  onValueChange: (id: string) => void;
  disabled?: boolean;
}) {
  return (
    <Select
      value={value}
      onValueChange={onValueChange}
      disabled={disabled || scopeOfWorks.length === 0}
    >
      <SelectTrigger className="w-full" aria-label={t("Leistung")}>
        <SelectValue placeholder={t("Keine Leistung vorhanden")} />
      </SelectTrigger>
      <SelectContent>
        {scopeOfWorks.map((sow) => (
          <SelectItem key={sow.id} value={sow.id}>
            {sow.title || t("Ohne Titel")}
            {sow.serviceVariation && (
              <span className="text-muted-foreground ml-2">
                {serviceVariationLabel(sow.serviceVariation)}
              </span>
            )}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
